import React from 'react';
import styled from 'styled-components';

const HotelBrandSelector = styled.div`
  margin: 0 10px;
  background: #F1F1F1;
  border-radius: 76px;
  box-sizing: content-box;
`;

const HotelBrandSelectorContent = styled.div`
  display: flex;
  flex-direction: row;
  padding: 4px 6px;
`;

const HotelBrandSelectorItem = styled.div`
  background: ${({active}) => active ? 'white' : '#F1F1F1'};
  border-radius: 30px;
  display: flex;
  flex: 1;
  text-align: center;
  height: 41px;
  justify-content: center;
  align-items: center;
  color: ${({active}) => active ? '#4FADA6' : '#919191'};
  width: 150px;
`;

const BrandSelector = ({onChangeHandler, selectedBarItem}) => {
  return (
    <HotelBrandSelector>
      <HotelBrandSelectorContent>
        <HotelBrandSelectorItem active={selectedBarItem.hotel} onClick={() => onChangeHandler('hotel')}>
          Hotel
        </HotelBrandSelectorItem>
        <HotelBrandSelectorItem active={selectedBarItem.brand} onClick={() => onChangeHandler('brand')}>
          Brand
        </HotelBrandSelectorItem>
      </HotelBrandSelectorContent>
    </HotelBrandSelector>
  );
};

export default BrandSelector;
